import { Icon, IconButton, Typography } from "@mui/material";

interface PopOverProps {
    message: string,
    label: string,
    id: string,
    handleClick: () => void,
}

export default function PopOver({ handleClick, label, ...other }: PopOverProps) {

    return (

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ width: '100%'}} >
                <div style={{width: '100%' }}>
                <Typography
                    component='div'
                    sx={{ flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: "center" }}
                    {...other}
                    style={{paddingRight: 0}}
                    >
                    <span style={{marginRight: 'auto'}}>{label}</span>
                    </Typography>
            </div>
            </div>
            <IconButton onClick={handleClick}><Icon
                fontSize="small"
            >
                plagiarism
            </Icon>
            </IconButton>
        </div>

    );
}
